// The group that makes someone a customer.
//
// MUST MATCH PORTAL_GROUP in ../server/portal-guard.js. The server's copy is
// the one that enforces — it refuses every surface but the portal — and this
// copy only decides where to SEND someone. They are separate because a
// browser bundle cannot import a server module, and the desk suite fails if
// they ever drift apart: a redirect that named a group the guard did not
// would drop customers back into a shell that refuses them everything.
export const PORTAL_CUSTOMER_GROUP = 'portal-customers';
